import { NotificationContainer, Scrollbar } from '@repo/go-ui';
import { clsx } from 'clsx';
import { observer } from 'mobx-react-lite';
import { type PropsWithChildren } from 'react';

import { DASHBOARD_NOTIFICATIONS_CONTAINER_ID } from 'src/app/notifications-store/NotificationsStore';
import { checkIsPortableDevice } from 'src/packages/shared/utils/checkIsPortableDevice';

import styles from './MainLayout.module.scss';

type Props = PropsWithChildren<{
  title: string;
}>;

export const MainLayout = observer(function MainLayout({ children }: Props) {
  return (
    <Scrollbar>
      <div className={clsx(styles.wrapper, checkIsPortableDevice() && styles.wrapper_portable)}>
        <div className={styles.contentWrapper}>
          <div className={styles.childrenWrapper}>{children}</div>
        </div>
        <NotificationContainer
          containerId={DASHBOARD_NOTIFICATIONS_CONTAINER_ID}
          enableMultiContainer
          position="bottom-left"
        />
      </div>
    </Scrollbar>
  );
});
